var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-summerize",staticStyle:{"height":"100vh"}},[_c('iframe',{staticStyle:{"overflow":"hidden","height":"100%","width":"100%"},attrs:{"src":_vm.iframeLink,"frameborder":"0","height":"100%","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }